/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductTypesQueryResponse,
  FindProductTypesQueryParams,
} from "../types/FindProductTypes.ts"

export const findProductTypesQueryKey = (
  params?: FindProductTypesQueryParams
) => [{ url: "/v1/product-type" }, ...(params ? [params] : [])] as const

export type FindProductTypesQueryKey = ReturnType<
  typeof findProductTypesQueryKey
>

/**
 * {@link /v1/product-type}
 */
export async function findProductTypes(
  params?: FindProductTypesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductTypesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/product-type`, params, ...requestConfig })
  return res
}

export function findProductTypesQueryOptions(
  params?: FindProductTypesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductTypesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductTypesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductTypesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductTypes(params, config)
    },
  })
}

/**
 * {@link /v1/product-type}
 */
export function useFindProductTypes<
  TData = ResponseConfig<FindProductTypesQueryResponse>,
  TQueryData = ResponseConfig<FindProductTypesQueryResponse>,
  TQueryKey extends QueryKey = FindProductTypesQueryKey,
>(
  params?: FindProductTypesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductTypesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findProductTypesQueryKey(params)

  const query = useQuery(
    {
      ...findProductTypesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
